// TOP - mv メインビジュアル
var mySwiper = new Swiper('.js-slider--main', {
	slidesPerView: 1,
	loop: true,
	effect: 'slider',
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
	autoplay: {
		delay: 3000,
	},
})

// TOP - Instgram
var mySwiper = new Swiper('.js-slider--instagram', {
	loop: true,
	effect: 'slider',
	speed: 1000,
	autoplay: {
		delay: 3000,
		stopOnLastSlide: false,
		disableOnInteraction: false,
		reverseDirection: false
	},
	// スライドの表示枚数：500px未満の場合
	slidesPerView: 2.5,
	breakpoints: {
		// スライドの表示枚数：500px以上の場合
		768: {
			slidesPerView: 3.2,
		}
	}
})

var mySwiper = new Swiper('.c-slider--gallery__container', {
	loop: true,
	effect: 'slide',
	speed: 2000,
	autoplay: {
		delay: 4000,
	},
	breakpoints: {
		767: {
			slidesPerView: 1,
			spaceBetween: 0,
			speed: 500,
		},
		// ウィンドウサイズが640px以下
		1920: {
			slidesPerView: 2.5,
			spaceBetween: 20

		}
	}
})


// -----------------------
// モデルハウス｜FVスライダー
// -----------------------
var swiperThumbnail = new Swiper(".p-modelhouse__fv__slider-thumbnail .swiper", {
	slidesPerView: 6,
	spaceBetween: 1,
	freeMode: true,
	watchSlidesProgress: true,
	breakpoints: {
		768: {
			spaceBetween: 8,
		},
	},
});

var swiperMain = new Swiper(".p-modelhouse__fv__slider .swiper", {
	autoHeight: true,
	effect: "slide",
	preloadImages: false,
	lazy: {
		loadPrevNext: true,
	},
	slidesPerView: 1.1,
	spaceBetween: 8,
	centeredSlides: true,
	speed: 1000,
	loop: true,

	autoplay: { // 自動再生
		delay: 5000, // 1秒後に次のスライド
	},
	navigation: {
		nextEl: ".p-modelhouse__fv__slider .swiper-button-next",
		prevEl: ".p-modelhouse__fv__slider .swiper-button-prev",
	},
	thumbs: {
		swiper: swiperThumbnail,
	},
	breakpoints: {
		768: {
			spaceBetween: 20,     // 768px以上の場合
			slidesPerView: 1.1,   // 768px以上の場合
		},
	},
});


// -----------------------
// モデルハウス｜ポイントスライダー
// -----------------------
var swiperThumbnail_point = new Swiper(".p-modelhouse__point__slider-thumbnail .swiper", {
	autoHeight: true,
	effect: "fade",
	slidesPerView: 1,
	freeMode: true,
	watchSlidesProgress: true,
});
var swiperMain_point = new Swiper(".p-modelhouse__point__slider .swiper", {
	effect: "slide",
	preloadImages: false,
	lazy: {
		loadPrevNext: true,
	},
	slidesPerView: 2,
	spaceBetween: 35,
	centeredSlides: true,
	speed: 500,
	loop: true,

	autoplay: { // 自動再生
		delay: 5000, // 1秒後に次のスライド
	},
	navigation: {
		nextEl: ".p-modelhouse__point__slider .swiper-button-next",
		prevEl: ".p-modelhouse__point__slider .swiper-button-prev",
	},
		thumbs: {
		swiper: swiperThumbnail_point,
	},
	breakpoints: {
		768: {
			spaceBetween: 60,
			slidesPerView: 3,
		},
		1200: {
			spaceBetween: 100,
			slidesPerView: 3,
		},
		1400: {
			spaceBetween: 120,
			slidesPerView: 3,
		},
	},
});
